/*eslint-disable*/
import React from "react";
import { withRouter } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { Nav, Collapse } from "reactstrap";
import { withCookies } from "react-cookie";
import { compose } from "react-apollo";
import { TOKEN_KEY } from "utils/auth.js";
import logo from "assets/img/kartraklogo.png";
import AuthorizedOperator from "./AuthorizedOperator";
import SystemUpdate from "./SystemUpdate";

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getCollapseStates(props.routes);
  }
  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.pathname.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }

  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = routes => {
    return routes.map((prop, key) => {
      if (prop.redirect || prop.isHidden) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        return (
          <li
            className={this.getCollapseInitialState(prop.views) ? "active" : ""}
            key={key}
          >
            <a
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              onClick={e => {
                e.preventDefault();
                this.setState(st);
              }}
            >
              {prop.icon !== undefined ? (
                <React.Fragment>
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b className="caret" />
                  </p>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">
                    {prop.name}
                    <b className="caret" />
                  </span>
                </React.Fragment>
              )}
            </a>
            <Collapse isOpen={this.state[prop.state]}>
              <ul className="nav">{this.createLinks(prop.views)}</ul>
            </Collapse>
          </li>
        );
      }
      return (
        <li
          className={this.activeRoute(prop.layout + prop.path)}
          key={key}
        >
          <NavLink to={prop.layout + prop.path} activeClassName="">
            {prop.icon !== undefined ? (
              <React.Fragment>
                <i className={prop.icon} />
                <p className="sidebar-option">{prop.name}</p>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span className="sidebar-mini-icon">{prop.mini}</span>
                <span className="sidebar-normal">{prop.name}</span>
              </React.Fragment>
            )}
          </NavLink>
        </li>
      );
    });
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute = routeName => {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  handleLogout = e => {
    e.preventDefault();
    this.props.cookies.remove(TOKEN_KEY, { path: "/" });
    window.location = "/login";
  }

  render() {
    return (
      <div
        className="sidebar"
        data-color={this.props.bgColor}
        data-active-color={this.props.activeColor}
      >
        <div className="logo">
          <a
            href="https://www.kartrak.app/"
            className="simple-text logo-mini"
          >
            <div className="logo-img">
              <img src={logo} alt="react-logo" />
            </div>
          </a>
          <a
            href="https://www.kartrak.app/"
            className="simple-text logo-normal"
          >
            Kartrak
          </a>
        </div>

        <div className="sidebar-wrapper">
          <Nav>
            {this.createLinks(this.props.routes)}
            <li>
              <NavLink to="#" onClick={e => this.handleLogout(e)} activeClassName="">
                <React.Fragment>
                  <i className="nc-icon nc-button-power"/>
                  <p className="sidebar-option">Logout</p>
                </React.Fragment>
              </NavLink>
            </li>
          </Nav>
          <AuthorizedOperator />
          <SystemUpdate />
        </div>
      </div>
    );
  }
}

export default compose(
  withCookies,
  withRouter
)(Sidebar);
